import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RenderingState, ErrorInfo } from 'redux/types';
import { RootState } from 'redux/root-reducer';

const initialState: RenderingState = {
  isLoading: false,
  success: false,
  error: {
    message: '',
    statusCode: null,
  },
};
const listInvitationsSlice = createSlice({
  name: 'LIST_INVITATIONS',
  initialState,
  reducers: {
    loading: (state) => {
      state.isLoading = true;
    },
    success: (state) => {
      state.isLoading = false;
      state.error.message = '';
      state.error.statusCode = null;
    },
    failure: (state, action: PayloadAction<ErrorInfo>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    resetToInitials: (state) => {
      state.isLoading = false;
      state.success = false;
      state.error.message = '';
      state.error.statusCode = null;
    },
  },
});

// REDUCER
export default listInvitationsSlice.reducer;

// ACTIONS
export const {
  loading,
  success,
  failure,
  resetToInitials,
} = listInvitationsSlice.actions;

// SELECTORS
export const selectIsLoading = (state: RootState) =>
  state.ui.invitations.listInvitations.isLoading;
export const selectSuccess = (state: RootState) =>
  state.ui.invitations.listInvitations.success;
export const selectError = (state: RootState) =>
  state.ui.invitations.listInvitations.error;
